import { VueQueryPlugin } from "@tanstack/vue-query";
import { createApp } from "vue";
import App from "./App.vue";
import { initFirebase } from "./config/firebase";
import { router } from "./router";

import { createClarityClient } from "./plugins/clarity";
import { createSentryClient } from "./plugins/sentry";
import "@propertechnologies/ajiaco/styles";
import "./style.css";

initFirebase().then(() => {
    const app = createApp(App);

    // Sentry client
    const { tracingMixin } = createSentryClient(app, router);
    app.mixin(tracingMixin);

    // Clarity analytics client
    const clarityClient = createClarityClient(app);
    clarityClient.initialize();

    app.use(router);
    app.use(VueQueryPlugin);

    app.mount("#app");
});
